import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/our-offices")({
  head: () => buildRouteHead("/en/our-offices", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/contact", replace: true });
  },
});
